<template>
  <div>
    <div class="flex wrap" v-if="mode===0">
      <div class="input-img-bg">
        <div class="input-img" :style="'background-image: url('+ img + ');'">
          <div class="input-img-intext" v-if="img!==''">
            <div class="input-img-close" @click.stop.prevent="del_img">
              <i class="material-icons">close</i>
            </div>
          </div>

          <div v-if="img===''" class="input-img-intext" @click="openModal">
            <i class="material-icons">add</i>
            <div style="font-size:12px" v-if="img === ''">이미지 추가</div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="mode===1">
      <button class="button" style="width: 75px;height: 28px !important;" @click="openModal">파일 선택</button>
    </div>

    <modal :name="`uploader-${index}`" :adaptive="true" :width="800" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <modal-image-uploader
          @addImage="res => addImage(res)"
          @closeModal="$modal.hide(`uploader-${index}`)"></modal-image-uploader>
      </div>
    </modal>
  </div>
</template>

<script>
  import ModalImageUploader from "../modal/ModalImageUploader";
  export default {
    components: {ModalImageUploader},
    props: {
      url: {
        type: String
      },
      disabled: {
        type: Boolean
      },
      idx: {
        type: Number
      },
      mode: {
        type: Number,
        default: 0
      }
    },
    data () {
      return {
        img: '',
        index: 0
      }
    },
    created() {
      if(this.idx)
        this.index = this.idx;
    },
    watch: {
      url: function(n, o) {
        this.img = this.image(n);
      }
    },
    mounted: function() {

      //file 타입인 경우
      if(typeof this.url === 'object') {
        this.set_img(this.img);
      }
      else {
        this.img = this.image(this.url);
      }
    },
    computed: {
      fileStyle(){
        return 'position: absolute; ' +
          'width: 1px; height: 1px; ' +
          'padding: 0; margin: -1px; ' +
          'overflow: hidden; ' +
          'clip:rect(0,0,0,0); border: 0';
      }
    },
    methods: {
      addImage(img) {
        this.$emit('update:url', img);
        this.$modal.hide(`uploader-${this.index}`);
      },
      openModal() {
        this.$modal.show(`uploader-${this.index}`);
      },
      del_img(e) {
        this.img = '';
        this.$emit('update:url', '');
      },

      // 이미지 화면에 설정
      set_img(img) {
        var reader = new FileReader();
        reader.onload = function(e) {
          this.img = e.target.result;
          this.$emit('onUpload', this.img);
          this.$emit('update:url', this.img);
          this.$emit('addImg');
        }.bind(this);
        if(img !== '')
          reader.readAsDataURL(img);
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
//@import '~assets/css/lp_main'
  $input-img-size = 80px
  .input-img-bg
    width $input-img-size
    height $input-img-size
    background-color white
    border 1px solid #dbdbdb
    border-radius 4px
    box-shadow inset 0 1px 2px rgba(10,10,10,0.1)
    display flex
    position relative
    margin-right 10px
    margin-bottom 10px
    flex-shrink 0
    cursor pointer

  .input-img-intext
    text-align center
    margin auto
    width 100%
    color #797979
    position absolute
    top 0
    left 0
    padding-top 20px
    height 100%

    > .input-img-close
      display none
      padding 2px 4px
      background-color rgba(255,255,255, 0.9)
      font-size 14px
      color #555
      position absolute
      top 0
      right 0
      margin -2px
      line-height 13px

    i
      font-size 24px

  &:hover
    .input-img-intext
    > .input-img-close
      display block

  .input-img
    width $input-img-size
    height $input-img-size
    background-size contain
    background-repeat no-repeat
    background-position center
    position absolute

  input
    padding 0
    border 0
</style>
